import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart, CategoryScale } from 'chart.js/auto';
import './style.css';

const BarChart = ({ chartData }) => {

    const options = {
        width: "4000px",
        height: "273px",
        plugins: {
            legend: {
                position: 'right', // Set legend position to right
                labels: {
                    usePointStyle: true, // Use point style for legend labels
                  },
            }
        },
    };


    const data = {
     
        labels: ['Approved', 'In Progress', 'Rejected','Returning Students'],

        datasets: [
            {
                borderColor: 'rgba(75,192,192,1)',
                borderWidth: 1,
                // hoverBackgroundColor: 'rgba(75,192,192,0.6)',
                hoverBackgroundColor: [
                    '#419733',
                    '#4F89E0',
                    '#E04F4F',
                    '#5F9EA0',
                    
                ],
                hoverBorderColor: 'rgba(75,192,192,1)',
                data: chartData,
                backgroundColor: [
                    '#419733',
                    '#4F89E0',
                    '#E04F4F',
                    '#5F9EA0',
                ],
            },
        ],
    };



    return (
        <div>
            <Doughnut data={data} options={options} plugins={[CategoryScale]} style={{ width: '100%' }} />
        </div>
    );
};

export default BarChart;
